import { Component, Inject, OnInit } from '@angular/core';

import { AlertService, AuthenticationService, FileBlobService, } from '../../_services/index';

import { LoginHelper } from '../../helpers/index';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DocumentRequest } from "../../_models/documentRequest";
import { DocumentRequestService } from "../../_services/documentRequest.service";
import { saveAs as importedSaveAs } from "file-saver";
import { SelectProjectControlItemComponent } from '../selectProjectControlItem/select-project-control-item.component';
import { Constants } from '../../helpers/constants';

@Component({
    standalone: false,
  selector: 'editdocumentrequest-component',
  templateUrl: 'editDocumentRequest.component.html',
  styleUrls: ['./editDocumentRequest.component.scss'],
  providers: [DialogService],
})

export class EditDocumentRequestComponent implements OnInit {
  documentRequest: DocumentRequest;
  documentRequestId: number;
  form: FormGroup;
  visibility: any = {};
  relatedControlsList: any[];
  controlsDialogRef: DynamicDialogRef | undefined;
  constants = Constants;

  constructor(
    public dialogRef: MatDialogRef<EditDocumentRequestComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog,
    public authenticationService: AuthenticationService,
    public documentRequestService: DocumentRequestService,
    public fileBlobService: FileBlobService,
    public alertService: AlertService,
    public formBuilder: FormBuilder,
    public dialogService: DialogService) {
  }

  ngOnInit() {
    this.relatedControlsList = [];
    this.documentRequest = this.data.documentRequest || {
      type: '',
      description: '',
      documentRequestGroupId: this.data.documentRequestGroupId,
      externalRequestId: this.data.externalRequestId,
      contact: '',
      status: '',
      requestDate: null,
      approveDate: null,
      dependencies: '',
      justification: '',
      comments: '',
      requestId: null,
      relatedControlsList: [],
      newComment: ''
    };
    this.form = this.formBuilder.group({
      type: ['', Validators.required],
      description: [''],
      contact: [''],
      status: [''],
      requestDate: [null],
      approveDate: [null],
      dependencies: [''],
      justification: [''],
      comments: [''],
      requestId: [null],
      newComment: ['']
    });
    this.form.setValue({
      type: this.documentRequest.type,
      description: this.documentRequest.description,
      contact: this.documentRequest.contact ?? '',
      status: this.documentRequest.status ?? '',
      requestDate: this.documentRequest.requestDate ?? '',
      approveDate: this.documentRequest.approveDate ?? null,
      dependencies: this.documentRequest.dependencies ?? null,
      justification: this.documentRequest.justification ?? '',
      comments: this.documentRequest.comments ?? '',
      requestId: this.documentRequest.externalRequestId ?? '',
      newComment: ''
    });
    this.relatedControlsList = this.documentRequest.relatedControlsList ?? []
  }

  onSave() {
    if (!this.form.valid) {
      Object.keys(this.form.controls).forEach(field => {
        const control = this.form.get(field);
        control.markAsTouched({ onlySelf: true });
      });
      return;
    }

    const currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    if (this.form.value.newComment) {
      const formattedDate = new Date();

      // Extract date components
      const day = formattedDate.getDate();
      const month = formattedDate.getMonth() + 1; // Months are zero-based
      const year = formattedDate.getFullYear().toString().slice(-2);

      // Format the date as MM/DD/YYYY
      const formattedDateString = `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year}`;

      this.form.value.comments = ((this.form.value.comments || '') + '\r\n' + (currentUser.firstName || currentUser.lastName ? currentUser.firstName + ' ' + currentUser.lastName : currentUser.emailAddress) + ', ' + formattedDateString + ': ' + this.form.value.newComment).trim();
    }

    this.alertService.clear();
    this.documentRequest.type = this.form.value.type;
    this.documentRequest.description = this.form.value.description;
    this.documentRequest.contact = this.form.value.contact;
    this.documentRequest.status = this.form.value.status;
    this.documentRequest.requestDate = this.form.value.requestDate;
    this.documentRequest.approveDate = this.form.value.approveDate;
    this.documentRequest.dependencies = this.form.value.dependencies;
    this.documentRequest.justification = this.form.value.justification;
    this.documentRequest.comments = this.form.value.comments;
    this.documentRequest.externalRequestId = this.form.value.requestId;
    this.documentRequest.relatedControls = this.relatedControlsList.map(c => c.id).join(";");
    this.documentRequestService.saveDocumentRequest(this.documentRequest)
      .subscribe(
        data => {
          this.onClose();
        },
        error => {
          const message = "An error occurred while updating item.";
          this.alertService.error(message);
        });
  }

  onClose(): void {
    this.dialogRef.close(this.documentRequest);
  }

  addToken(html) {
    return html ? html.replace(/api\/attachments\/file\?/gi, 'api/attachments/file?token=' + LoginHelper.getFileToken() + '&') : html;
  }

  generateReport(id) {
    this.documentRequestService.generateReport(id).subscribe(blob => {
      importedSaveAs(new Blob([blob]), 'DocumentRequest.docx');
    },
      error => {
        const errorMessage = 'Error during generation';
        this.alertService.error(errorMessage);
      });
  }

  public DownloadAttachment(fileName: string, isPath: boolean = false) {
    this.fileBlobService
      .downloadFile(fileName, 'DocumentRequest')
      .subscribe(blob => {
        importedSaveAs(new Blob([blob]), fileName);
      },
        error => {
          const errorMessage = error.status == 401 ? 'The logged in user does not have access to the file\'s location. ' : 'The referenced file no longer exists in the document library.';
          this.alertService.error(errorMessage);
        });
  }

  deleteAssessmentAttachment(item) {
    this.fileBlobService.deleteDocumentRequestAttachment(item.documentRequestAttachmentId)
      .subscribe((res) => {

        this.documentRequest.attachments.splice(this.documentRequest.attachments.indexOf(item), 1);

      },
        (error) => {
          const errorMessage = 'An error occurred while deleting attachment.';
          this.alertService.error(errorMessage);
        });
  }
  addControl() {
    this.controlsDialogRef = this.dialogService.open(
      SelectProjectControlItemComponent,
      {
        width: '70%',
        contentStyle: { overflow: 'auto' },
        baseZIndex: 10010,
        maximizable: true,
        data: {},
        header: 'Select related controls',
      }
    );
    this.controlsDialogRef.onClose.subscribe((data: any) => {
      if (data) {
        this.relatedControlsList.push({
          id: data.projectControlItemId,
          projectId: data.projectId,
          projectName: data.projectName,
          complianceAreaControlId: data.controlItem.complianceAreaControlId,
        });
      }
    });
  }

  removeControl(id) {
    this.relatedControlsList = this.relatedControlsList.filter(
      (c) => c.id !== id
    );
  }

  public AddAssessmentAttachment(event) {
    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.fileBlobService.postDocumentRequestAttachment(file, this.documentRequest.documentRequestId, this.documentRequest.externalRequestId)
        .subscribe((res) => {
          this.documentRequest.attachments.push(res);
        });
    }
  }

}
